<div class="navigation-heading">Workspace</div>
<mat-nav-list aria-label="Main navigation">
  <a
    mat-list-item
    routerLink="/"
    routerLinkActive="selected"
    [routerLinkActiveOptions]="{ exact: true }"
    (click)="navigate.emit()"
  >
    <mat-icon matListItemIcon aria-hidden="true">space_dashboard</mat-icon>
    <span matListItemTitle>Home</span>
  </a>
  <a mat-list-item routerLink="/inbox" routerLinkActive="selected" (click)="navigate.emit()">
    <mat-icon matListItemIcon aria-hidden="true">inbox</mat-icon>
    <span matListItemTitle>Pending Approvals</span>
  </a>
  <a
    mat-list-item
    routerLink="/notifications"
    routerLinkActive="selected"
    (click)="navigate.emit()"
  >
    <mat-icon matListItemIcon aria-hidden="true">notifications</mat-icon>
    <span matListItemTitle>Notifications</span>
  </a>
</mat-nav-list>

@if (context.accessibleApps().length) {
  <div class="navigation-heading">Applications</div>
  <mat-nav-list aria-label="Applications">
    @for (app of context.accessibleApps(); track app.id) {
      <a
        mat-list-item
        [routerLink]="context.routeFor(app)"
        routerLinkActive="selected"
        (click)="navigate.emit()"
        [attr.data-color]="app.color"
        [matTooltip]="app.code"
        matTooltipPosition="right"
      >
        <mat-icon matListItemIcon aria-hidden="true">{{ app.icon || 'apps' }}</mat-icon>
        <span matListItemTitle>{{ app.code }}</span>
      </a>
    }
  </mat-nav-list>
}

@if (context.canAdminister()) {
  <div class="navigation-heading">Administration</div>
  <mat-nav-list aria-label="Administration">
    @for (link of adminLinks(); track link.route) {
      <a
        mat-list-item
        [routerLink]="link.route"
        routerLinkActive="selected"
        (click)="navigate.emit()"
      >
        <mat-icon matListItemIcon aria-hidden="true">{{ link.icon }}</mat-icon>
        <span matListItemTitle>{{ link.label }}</span>
      </a>
    }
  </mat-nav-list>
}

<div class="sidebar-brand" aria-hidden="true">
  <img src="pgc-logo.png" alt="" />
  <span>
    <strong>EBP </strong>
    <small>Your Workflow. Our Priority.</small>
  </span>
</div>
